export enum DevelopmentStatus {
  ACTIVED = 1,
  ARCHIVED = 2,
}
